import { useContext, useMemo } from 'react';
import { useGlobalQueries } from '@/hooks/use-global-queries';
import { AppContext } from '@/contexts/app-context';

export const FooterBottom = () => {
    const context = useContext(AppContext);
    const { footerQuery, pageQuery } = useGlobalQueries();

    const footerCopyright = useMemo(
        () =>
            pageQuery?.data?.market_type === 'cluster'
                ? footerQuery?.data?.clusterCopyright?.trim() || footerQuery?.data?.copyright || ''
                : footerQuery?.data?.copyright || '',
        [pageQuery.data, footerQuery.data]
    );

    return (
        <div className="r-w-full r-bg-[#efe8e4]">
            <div
                data-component="footer-bottom"
                className="r-container r-relative r-z-30 r-p-4 r-text-black max-md:r-pb-16 max-md:r-text-center md:r-px-8"
            >
                <div className="md:r-flex md:r-justify-between">
                    <p className="r-text-xs md:r-text-sm md:r-font-semibold">{footerCopyright}</p>
                    <p className="r-text-xs max-md:r-pt-4">v{context.version}</p>
                </div>
            </div>
        </div>
    );
};
